import * as React from 'react';
import Form from 'antd/lib/form';
import Modal from 'antd/lib/modal';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';

import { OrgUpdatable } from '@/actions/organization';

import { Agent, RunwayResponseType } from '@/types';
import { globalMessage } from '@/utils/globalMessage';
import { useCallUpdatable } from '@/utils/hooks/helpers';

import { DeliveryFormValues, toDeliveryRequest, DeliveryFields } from './AgentDeliveryFields';

interface RecreateAgentWebhookModalProps {
    orgId: string;
    agent: Agent;
    onClose: () => void;
}

const RecreateAgentWebhookModal: React.FC<RecreateAgentWebhookModalProps> = ({ orgId, agent, onClose }) => {
    const [form] = Form.useForm<DeliveryFormValues>();
    const [recreate, isLoading, responseType, error] = useCallUpdatable(OrgUpdatable.RecreateAgentWebhook, { orgId });

    React.useEffect(() => {
        if (responseType === RunwayResponseType.Success) {
            globalMessage.success('Webhook recreated.');
            onClose();
        }
    }, [responseType, onClose]);

    React.useEffect(() => {
        if (error) {
            globalMessage.error(error);
        }
    }, [error]);

    return (
        <Modal
            open
            destroyOnClose
            title={`Recreate webhook for ${agent.name}`}
            okText="Recreate"
            okButtonProps={{ loading: isLoading }}
            onOk={() => form.submit()}
            onCancel={onClose}
        >
            <Space direction="vertical" size={16} style={{ width: '100%' }}>
                <Text type="secondary">The previous webhook no longer exists. Enter its URL again to recreate it.</Text>
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{ url: '' }}
                    onFinish={(values) => recreate({ agentId: agent.id, ...toDeliveryRequest(values) })}
                >
                    <DeliveryFields />
                </Form>
            </Space>
        </Modal>
    );
};

export default RecreateAgentWebhookModal;
